// extracted by mini-css-extract-plugin
export default {"footerLogo":"HmBwi","logoRus":"n3DEq","logoUzb":"UVl2X","logoKaz":"peTus","image":"zCgjO"};